var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-product-card',{attrs:{"color":_vm.color,"hover":"","product":_vm.item,"ripple":""},on:{"click":_vm.toggle}},[(_vm.item.validated)?_c('v-item-card-validation-data',{attrs:{"item":_vm.item}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }